module.exports = __webpack_public_path__ + "static/media/card-logo-visa.e6f1a872.svg";